import { render } from "./printReport.vue?vue&type=template&id=766d6fc0"
import script from "./printReport.vue?vue&type=script&lang=js"
export * from "./printReport.vue?vue&type=script&lang=js"

import "./printReport.vue?vue&type=style&index=0&id=766d6fc0&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__